export default __webpack_public_path__ + "static/media/Logout_White.f537144d.svg";